export default {
  login_mfa: {
    title: '@:login.title',
    message: 'Tin nhắn SMS chứa mã xác minh đã được gửi đến số điện thoại bạn đăng ký.\nNhập mã xác minh và nhấn nút đăng nhập.\nThời gian hết hạn là 5 phút',
    button_submit: '@:login.login',
    button_resend: 'Gửi lại mã xác minh',
    alert_success: 'Mã xác minh đã được gửi lại',
    alert_error: 'Gửi lại mã xác minh không thành công',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'Không thể sử dụng xác thực bằng SMS vì số điện thoại của người dùng không được đăng ký.\n\nLiên hệ với quản trị viên của công ty bạn để thêm số điện thoại của bạn.',
  },
}
